import * as React from 'react';
import type { SVGProps } from 'react';

const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m1 7.5v6h-2v-6zm-1-3.9a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
  </svg>
);
export default SvgInfo;
